import React, { useState } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
const tomos = [{
  icon: '🔵',
  title: 'Tomo 1 — Fundamentos de Enfermería',
  subtitle: 'Actuá con seguridad desde el inicio',
  accent: 'border-l-blue-500',
  items: ['Bases clínicas esenciales', 'Comprensión del entorno hospitalario', 'Rol del enfermero/a en la práctica', 'Seguridad básica en procedimientos', 'Primeros pasos con claridad']
}, {
  icon: '🟢',
  title: 'Tomo 2 — Protocolos Clínicos',
  subtitle: 'Pasos claros para actuar correctamente',
  accent: 'border-l-green-500',
  items: ['Protocolos básicos de actuación', 'Secuencia correcta de procedimientos', 'Checklist clínico paso a paso', 'Seguridad antes, durante y después', 'Reducción de errores frecuentes', 'Aplicación práctica en guardia']
}, {
  icon: '🟡',
  title: 'Tomo 3 — Farmacología Aplicada',
  subtitle: 'Tomá decisiones seguras con medicamentos',
  accent: 'border-l-yellow-400',
  items: ['Tipos de fármacos más utilizados', 'Vías de administración', 'Cálculo y dosificación básica', 'Errores frecuentes en medicación', 'Seguridad en la administración', 'Aplicación en situaciones reales']
}, {
  icon: '🟣',
  title: 'Tomo 4 — Situaciones Clínicas',
  subtitle: 'Cómo actuar en casos reales',
  accent: 'border-l-purple-500',
  items: ['Evaluación rápida del paciente', 'Identificación de urgencias', 'Toma de decisiones clínicas', 'Prioridad de intervención', 'Resolución de situaciones comunes', 'Pensamiento clínico aplicado']
}, {
  icon: '🔴',
  title: 'Tomo 5 — Organización del Trabajo',
  subtitle: 'Tomá el control de tu turno',
  accent: 'border-l-red-500',
  items: ['Gestión del tiempo en guardia', 'Priorización de tareas', 'Organización de pacientes', 'Manejo del estrés en turno', 'Flujo de trabajo eficiente', 'Control y seguimiento de actividades']
}, {
  icon: '🟤',
  title: 'Tomo 6 — Formatos y Documentos',
  subtitle: 'Herramientas listas para usar',
  accent: 'border-l-amber-800',
  items: ['Plantillas clínicas imprimibles', 'Registros básicos de enfermería', 'Checklists de seguridad', 'Guías rápidas de acción', 'Documentación organizada', 'Uso práctico en el día a día']
}];
const features = ['guías paso a paso', 'herramientas prácticas', 'ejemplos reales', 'aplicación inmediata', 'uso en guardia'];
export function TomosSection() {
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-296">
      <div className="max-w-xl mx-auto" data-id="element-297">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-3" data-id="element-298">
          📚 LO QUE RECIBES
        </h2>
        <p className="text-center text-gray-400 text-sm mb-8" data-id="element-299">
          6 tomos completos listos para usar
        </p>

        <div className="space-y-3 mb-10" data-id="element-300">
          {tomos.map((tomo, idx) => {
          const isOpen = expandedIdx === idx;
          return <div key={idx} className={`bg-gray-900 border border-gray-800 border-l-4 ${tomo.accent} rounded-lg overflow-hidden`} data-id="element-301">
                <button onClick={() => setExpandedIdx(isOpen ? null : idx)} className="w-full p-4 flex items-start gap-3 text-left" data-id="element-302">
                  <span className="text-2xl flex-shrink-0" data-id="element-303">{tomo.icon}</span>
                  <div className="flex-grow min-w-0" data-id="element-304">
                    <h3 className="text-sm font-bold text-white mb-0.5" data-id="element-305">
                      {tomo.title}
                    </h3>
                    <p className="text-xs text-gray-500" data-id="element-306">{tomo.subtitle}</p>
                  </div>
                  {isOpen ? <ChevronUp size={18} className="text-brand-yellow flex-shrink-0 mt-1" data-id="element-307" /> : <ChevronDown size={18} className="text-gray-600 flex-shrink-0 mt-1" data-id="element-308" />}
                </button>
                {isOpen && <div className="px-4 pb-4 pl-12" data-id="element-309">
                    <div className="space-y-2" data-id="element-310">
                      {tomo.items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-311">
                          <CheckCircle2 className="text-green-500 flex-shrink-0" size={14} data-id="element-312" />
                          <span className="text-xs text-gray-400" data-id="element-313">{item}</span>
                        </div>)}
                    </div>
                  </div>}
              </div>;
        })}
        </div>

        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 mb-10" data-id="element-314">
          <h3 className="text-base font-bold text-center text-brand-yellow mb-4" data-id="element-315">
            ✨ Cada tomo incluye:
          </h3>
          <div className="space-y-3" data-id="element-316">
            {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-317">
                <CheckCircle2 className="text-green-500 flex-shrink-0" size={18} data-id="element-318" />
                <span className="text-sm text-gray-300 font-medium" data-id="element-319">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}